<template>
  <div class="image-editor d-flex flex-column justify-space-between">
    <div
      style="height: 500px; background-color: rgba(0, 0, 0, 0.5)"
      class="d-flex flex-row align-center justify-center"
    >
      <VueCropper
        v-show="src"
        :src="src"
        :key="src"
        ref="cropper"
        alt="Source Image"
        :containerStyle="{ maxHeight: '100%' }"
      ></VueCropper>
    </div>

    <v-toolbar>
      <!--Zoom -->
      <v-btn icon>
        <v-icon @click="zoom(0.2)">mdi-plus</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon @click="zoom(-0.2)">mdi-minus</v-icon>
      </v-btn>

      <!--Move -->
      <v-btn icon>
        <v-icon @click="move(10, 0)">mdi-arrow-left</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon @click="move(-10, 0)">mdi-arrow-right</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon @click="move(0, 10)">mdi-arrow-up</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon @click="move(0, -10)">mdi-arrow-down</v-icon>
      </v-btn>

      <!--Rotate -->
       <v-btn icon>
        <v-icon @click="rotate(90)">mdi-rotate-right</v-icon>
      </v-btn>
       <v-btn icon>
        <v-icon @click="rotate(-90)">mdi-rotate-left</v-icon>
      </v-btn>
      <v-btn icon>
        <v-icon @click="reset()">mdi-autorenew</v-icon>
      </v-btn>

      <v-spacer></v-spacer>

      <v-btn
        color="secondary"
        @click="$emit('cancel')"
      >{{ $t('commons.cancel') }}</v-btn>

      <v-btn
        class="ml-4"
        color="primary"
        @click="$emit('change', saveCropImage())"
      >{{ $t('commons.accept') }}</v-btn>
    </v-toolbar>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  components: { VueCropper },
  props: {
    src: String,
    name: String,
  },
  methods: {
    zoom(percent) {
      this.$refs.cropper.relativeZoom(percent);
    },
    cropImage() {
      // get image data for post processing, e.g. upload or setting image src
      this.cropImg = this.$refs.cropper.getCroppedCanvas();
    },
    move(offsetX, offsetY) {
      this.$refs.cropper.move(offsetX, offsetY);
    },
    reset() {
      this.$refs.cropper.reset();
    },
    rotate(deg) {
      this.$refs.cropper.rotate(deg);
    },
    saveCropImage() {
      console.log(this.$refs.cropper);
      const fileEdit = this.$refs.cropper.getCroppedCanvas({
        maxWidth: 3072,
        maxHeight: 3072,
        imageSmoothingEnabled: 'false',
      });

      return {
        name: this.name,
        blob: fileEdit.toDataURL(),
      };
    },
  },
};
</script>
<style scoped>
.icon {
  position: absolute;
  top: 10px;
  right: 0;
  background: #e2e2e2;
  border-radius: 100%;
  width: 30px;
  height: 30px;
  line-height: 30px;
  vertical-align: middle;
  text-align: center;
  color: #0000ff;
  font-size: 14px;
  cursor: pointer;
}
</style>
<style>
.image-editor .cropper-modal {
  opacity: 0;
}
</style>
